<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="flex-none row m-0 p-2 background-primary-blue height-70px w-100 shadow z-max align-items-center">
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="back()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
                </div>
            </div>
        </div>
        <div class="col-8 m-auto">
            <div class="text-center color-white fs-lg">Add LoRa gateway</div>
        </div>
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="close()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-x fa-xl"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        @if (!store.deviceId()) {
            <app-device-id-input
                (deviceIdSelected)="processDeviceId($event)"
                [deviceName]="'device'"
                [inputLength]="16"
                [showImage]="false" />
        } @else if (searchingForDeviceId()) {
                <app-spinner [loading]="true" />
        } @else {
            <div class="d-flex flex-column gap-3">
                <div class="fw-bold">Device ID: {{ store.deviceId() }}</div>
                <div class="input-group">
                    <input (input)="setName($event)"
                            [ngClass]="{'is-invalid': store.name() === undefined}"
                            [value]="store.name() || ''"
                            class="form-control m-auto"
                            placeholder="Name"
                            required
                            type="text">
                </div>
                <div class="d-flex gap-3">
                    <div class="input-group">
                        <input (input)="setLat($event)"
                                [ngClass]="{'is-invalid': store.lat() === undefined}"
                                [value]="store.lat() || ''"
                                class="form-control m-auto"
                                placeholder="Latitude"
                                required
                                type="number">
                    </div>
                    <div class="input-group">
                        <input (input)="setLong($event)"
                                [ngClass]="{'is-invalid': store.long() === undefined}"
                                [value]="store.long() || ''"
                                class="form-control m-auto"
                                placeholder="Longitude"
                                required
                                type="number">
                    </div>
                </div>
            </div>

            <app-generic-button
                (click)="onDropAPin()"
                description="Drop a pin for gateway"
                [alwaysShowText]="true"
                [buttonText]="'Drop a pin'"
                [disabled]="creatingGateway()"
                [primaryIcon]="'fa-solid fa-pin'"/>

            <app-generic-button
                (click)="processNewGateway()"
                description="Create new gateway"
                [alwaysShowText]="true"
                [buttonText]="'Add'"
                [disabled]="!canProcessNewGateway()"
                [loading]="creatingGateway()"
                [primaryIcon]="'fa-solid fa-check'"/>

            <app-generic-button
                (click)="reset()"
                description="Cancel adding new gateway"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info'"
                [buttonText]="'Cancel'"/>
        }
    </div>
</div>
